import {
  PRODUCT_TYPES,
  getProductTypeByProductOfferingTypes,
} from '../../utils/catalog';

export const hasPackProductAvailable = (products) => {
  const hasPackProduct = products.some((product) => {
    return (
      product && product.parentProduct && getProductTypeByProductOfferingTypes(product.parentProduct.productOfferingTypes)
      === PRODUCT_TYPES.PACK
    );
  });
  return hasPackProduct;
};

export const getFiberProductOfPackProduct = (products) => {
  const product = products.find((prod) => {
    return (
      prod && prod.parentProduct && getProductTypeByProductOfferingTypes(prod.parentProduct.productOfferingTypes)
      === PRODUCT_TYPES.PACK
    );
  });
  return product;
};
